export default {
  fields: {
    factorLevel: {
      label: "Factory level",
      hint: {
        intro: `Select the patient baseline value type:`,
        unknownBaseline: `Select "?" if you do not know the patient baseline.`,
        equals: `Select "=" if an exact measured laboratory value is entered. This option should be selected for values above the limit of qualification (LOQ) of your laboratory.
        `,
        lessThan: `Select "<" to indicate patient baseline values below the limit of qualification (BLQ), which is lower than your laboratory can measure.`,
      },
    }
  },
}